import { Component, computed, inject, OnInit, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthApiService } from '@p2p/auth/api';
import { UserRole } from '@p2p/users/domain';
import _ from 'lodash';

import { MenuInfoStore } from './menu-info.store';

@Component({
    selector: 'app-menu-info',
    templateUrl: './menu-info.component.html',
    styleUrls: ['menu-info.component.scss'],
    providers: [MenuInfoStore]
})
export class MenuInfoComponent implements OnInit {
    readonly UserRoles = UserRole;

    private readonly authApiService = inject(AuthApiService);
    private readonly menuInfoStore = inject(MenuInfoStore);

    readonly toggleSwitched = output<void>();

    readonly account = toSignal(this.authApiService.account$);
    readonly role = computed(() => this.account()?.role);
    readonly rates = toSignal(this.menuInfoStore.rates$);
    readonly ratesToShow = computed(() => {
        if (!this.rates) {
            return [];
        }

        return _.keys(this.rates()).map((key) => ({
            currency: key,
            value: this.rates()[key].toFixed(3)
        }));
    });

    ngOnInit(): void {
        if (this.account()?.role === UserRole.Trader || this.account()?.role === UserRole.Operator) {
            this.menuInfoStore.loadRates();
            this.menuInfoStore.pollRates();
        }
    }

    toggleSwitchedHandler(): void {
        this.toggleSwitched.emit();
    }
}
